import React from "react";

import { config } from "@app/config";

import { useSearchspringOption } from "@app/hooks/use-searchspring-option";
import { SearchspringTrendingProvider, useSearchspringSearchContext } from "@app/providers/searchspring";

import { Icon } from "@app/components/icon";
import { SearchInput } from "@app/components/search-input";
import { SearchResults } from "@app/components/search-results";
import { SearchTrending } from "@app/components/search-trending";

export type Props = {
  config: typeof config;
};

export function InstantSearch({ config }: Props) {
  const { response } = useSearchspringSearchContext();

  const query = useSearchspringOption("query", {
    defaultValue: "",
  });

  return (
    <div x-data="modal" id="search">
      <div x-bind="portal" className="fixed inset-x-0 top-0">
        <div className="overflow-y-scroll anchor-top no-scrollbar max-md:bottom-0">
          <div x-bind="content" className="flex flex-col bg-neutrals-white">
            <div className="sticky top-0 z-20 flex items-center justify-between gap-3 px-8 py-4 bg-neutrals-white">
              <div className="hidden md:block">
                <img src={window.SHOPIFY_DATA.shop?.logo_badge} />
              </div>
              <SearchInput />
              <button className="flex items-center gap-2 shrink-0" x-bind="close">
                <span className="font-semibold max-md:hidden">Close Search</span>
                <Icon id="Cross" className="size-3.5" />
              </button>
            </div>
            {!response ? null : (
              <div className="flex flex-col items-center max-h-full px-4 py-6">
                {!query ? (
                  <div className="w-full max-w-208">
                    <SearchspringTrendingProvider category="products">
                      <SearchTrending />
                    </SearchspringTrendingProvider>
                  </div>
                ) : response.results.length === 0 ? (
                  <div className="flex flex-col w-full gap-8 max-w-208">
                    <div className="flex flex-col gap-4">
                      <h4>No results for "{query}"</h4>
                      <hr className="bg-neutrals-grey-4" />
                      <ul className="leading-8 list-disc list-inside">
                        <li>Check for misspelling</li>
                        <li>Remove redundant keywords (e.g. products)</li>
                        <li>Try different words to describe your search.</li>
                      </ul>
                    </div>
                    <SearchspringTrendingProvider category="products">
                      <SearchTrending />
                    </SearchspringTrendingProvider>
                  </div>
                ) : (
                  <div className="flex flex-col w-full gap-4">
                    <SearchResults />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
